module.exports = ".product-img {\n  width: 100px !important;\n  height: 100px !important; }\n"